// Lib
import { KPI_VALUE_CLASSIC } from '@/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const videoViews10SecConfig: KpiType<typeof DefaultLoader> = {
    name: 'kpi.pinterest.video_views_10_sec',
    id: 'video_10s_views',
    icon: {
        name: 'impressions',
        style: colors.purple
    },
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_50,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    loader: DefaultLoader
};
